export enum TraySize {
  A = "A",
  B = "B",
  C = "C",
  D = "D",
  E = "E",
  F = "F",
}

export type TTraySize = typeof TraySize[keyof typeof TraySize];

export const ALL_TRAY_SIZES: TraySize[] = [
  TraySize.A,
  TraySize.B,
  TraySize.C,
  TraySize.D,
  TraySize.E,
  TraySize.F,
] as const;
